<template>
    <div>
        <label class="d-block">Mögliche Dateianhänge</label>
        <b-table ref="documentTable" :fields="attachmentFields"
            :items="preparedAttachments">
            <template v-slot:cell(selected)="rowData">
                <b-form-checkbox :checked="rowData.item.checked"
                    :value="rowData.item.name"
                    @change="(checked) => handleCheckboxChange(rowData, checked)"/>
            </template>
            <template v-slot:cell(label)="rowData">
                <a v-if="rowData.item.fileId !== null"
                   :href="getLinkForFile(rowData.item.fileId)"
                   target="_blank"
                   title="Vorschau">
                    {{ rowData.item.label }}
                </a>
                <span v-else>
                    {{ rowData.item.label }}
                </span>
            </template>
        </b-table>
    </div>
</template>

<script>
    import Container from '@services/Container';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'StaticAttachments',
        props: {
            attachments: {
                type: Array,
                required: true,
            },
            defaultCheckAttachments: {
                type: Boolean,
                default: false,
            },
            form: {
                type: Object,
                required: true,
            },
        },
        data() {
            const recordId = parseInt(this.$route.params.recordId);
            return {
                recordId,
                attachmentFields: [
                    {
                        key: 'selected',
                        label: 'Auswählen',
                        thStyle: {width: '95px'},
                    },
                    {
                        key: 'label',
                        label: 'Dokument',
                    },
                    {
                        key: 'categoryName',
                        label: 'Kategorie',
                    },
                ],
                preparedAttachments: [],
            }
        },
        mounted() {
            if (Array.isArray(this.attachments)) {
                this.attachments.forEach(attachment => {
                    if (this.defaultCheckAttachments) {
                        attachment.checked = attachment.name;
                    } else {
                        attachment.checked = false;
                    }
                    this.preparedAttachments.push(attachment);
                });
            }
        },
        methods: {
            handleCheckboxChange(rowData, checked) {
                if (rowData.item.name === 'selectAll') {
                    this.preparedAttachments.forEach((attachment, idx) => {
                        attachment.checked = checked !== false ? attachment.name : false;
                        this.$set(this.preparedAttachments, idx, attachment);
                    });
                } else {
                    if (checked) {
                        rowData.item.checked = rowData.item.name;
                    } else {
                        rowData.item.checked = false;
                    }
                }
                this.form.setData(this.preparedAttachments);
            },
            getLinkForFile(fileId) {
                return recordRepository.buildStaticAttachmentFilePreviewUrl(this.recordId, fileId);
            },
        },
    }
</script>
